import { render, staticRenderFns } from "./AddMarketForm.vue?vue&type=template&id=4ffea92c&"
import script from "./AddMarketForm.vue?vue&type=script&lang=js&"
export * from "./AddMarketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports